import { useLocation } from "react-router-dom";

export const useUrlQuery = (): URLSearchParams => {
  return new URLSearchParams(useLocation().search);
};
